import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	getStartedNonFinal: {
		id: 'eoc-changeboarding.transition-home.transition-home-button.get-started-non-final',
		defaultMessage: 'Shifting from Opsgenie to Jira',
		description: 'Text of the transitioning home floating button',
	},
	hideTransitionHomeNonFinal: {
		id: 'eoc-changeboarding.transition-home.transition-home-button.hide-transition-home-non-final',
		defaultMessage: 'Hide shifting guide',
		description: 'Text of the transitioning home floating button',
	},
});
